import { useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext"; // Or wherever your auth context is
// import { useWorkspaces } from './useWorkspaces'; // You might need this hook too

export interface PageNotification {
  id: string;
  type: "information" | "fail";
  icon: string;
  title: string;
  text: string;
  buttonText?: string;
  onClick?: () => void;
}

interface Props {
  openModal?: () => void;
}

export const useAccountNotifications = ({
  openModal,
}: Props): PageNotification[] => {
  const location = useLocation();
  const { currentUser } = useAuth();

  const notifications: PageNotification[] = [];

  const notificationFromState = location.state?.notification;
  if (notificationFromState === "workspace_under_deletion") {
    notifications.push({
      id: "workspace_deletion_status",
      type: "information",
      icon: "information",
      title: "Arbeidsområde under sletting",
      text: "Sletting av arbeidsområdet ditt er startet og du vil motta en e-post når prosessen er fullført.",
    });
  }

  if (currentUser?.notification) {
    notifications.push({
      id: "persistent_deletion_error",
      type: currentUser.notification?.type,
      icon: "error",
      title: currentUser.notification?.title,
      text: currentUser.notification?.text,
    });
  }

  if (currentUser?.workspaces?.length === 0 && openModal) {
    notifications.push({
      id: "create_workspace_prompt",
      type: "information",
      icon: "information",
      title: "Opprett nytt arbeidsmiljø",
      text: "For å kunne gjøre transkriberinger og redigere videoer må du opprette et nytt arbeidsmiljø.",
      buttonText: "Nytt arbeidsmiljø",
      onClick: () => openModal(),
    });
  }

  return notifications;
};
